/* ============================================================
   INTOUCH DEVELOPERS — COMING SOON JS
   ============================================================ */

(function(){

  /* CURSOR */
  if(window.matchMedia('(pointer:fine)').matches){
    const dot=document.createElement('div'),ring=document.createElement('div');
    dot.className='cur-dot'; ring.className='cur-ring';
    document.body.appendChild(dot); document.body.appendChild(ring);
    let mx=-200,my=-200,rx=-200,ry=-200;
    document.addEventListener('mousemove',e=>{
      mx=e.clientX;my=e.clientY;
      dot.style.transform=`translate(${mx}px,${my}px)`;
    });
    (function lerp(){
      rx+=(mx-rx)*.10;ry+=(my-ry)*.10;
      ring.style.transform=`translate(${rx}px,${ry}px)`;
      requestAnimationFrame(lerp);
    })();
    document.querySelectorAll('.cs-btn,.cs-contact-card').forEach(el=>{
      el.addEventListener('mouseenter',()=>ring.classList.add('hov'));
      el.addEventListener('mouseleave',()=>ring.classList.remove('hov'));
    });
    document.body.style.cursor='none';
    document.querySelectorAll('a,button').forEach(el=>el.style.cursor='none');
  }

  /* MOUSE GLOW */
  const glow=document.querySelector('.cs-mouse-glow');
  if(glow){
    document.addEventListener('mousemove',e=>{
      glow.style.left=e.clientX+'px';
      glow.style.top=e.clientY+'px';
    });
  }

  /* PARTICLES */
  const canvas=document.getElementById('cs-canvas');
  if(canvas){
    const ctx=canvas.getContext('2d');
    let W,H,particles=[];
    function resize(){W=canvas.width=window.innerWidth;H=canvas.height=window.innerHeight;}
    resize();
    window.addEventListener('resize',resize);
    function rand(a,b){return Math.random()*(b-a)+a;}
    class P{
      constructor(){this.reset();}
      reset(){this.x=rand(0,W);this.y=rand(H*.2,H);this.r=rand(.5,1.6);this.vx=rand(-.1,.1);this.vy=rand(-.16,-.04);this.life=rand(.4,1);this.dec=rand(.0006,.0018);this.hue=rand(265,305);}
      tick(){this.x+=this.vx;this.y+=this.vy;this.life-=this.dec;if(this.life<=0||this.y<-10)this.reset();}
      draw(){ctx.beginPath();ctx.arc(this.x,this.y,this.r,0,Math.PI*2);ctx.fillStyle=`hsla(${this.hue},72%,68%,${this.life*.45})`;ctx.fill();}
    }
    for(let i=0;i<100;i++)particles.push(new P());
    (function loop(){ctx.clearRect(0,0,W,H);particles.forEach(p=>{p.tick();p.draw();});requestAnimationFrame(loop);})();
  }

  /* RIPPLE ON BUTTONS */
  document.querySelectorAll('.cs-btn').forEach(btn=>{
    btn.addEventListener('click',e=>{
      const old=btn.querySelector('.cs-btn-ripple');if(old)old.remove();
      const r=btn.getBoundingClientRect(),size=Math.max(r.width,r.height)*2;
      const el=document.createElement('span');
      el.className='cs-btn-ripple';
      el.style.cssText=`width:${size}px;height:${size}px;left:${e.clientX-r.left-size/2}px;top:${e.clientY-r.top-size/2}px;`;
      btn.appendChild(el);
      el.addEventListener('animationend',()=>el.remove());
    });
  });

  /* MAGNETIC BUTTONS */
  document.querySelectorAll('.cs-btn').forEach(btn=>{
    btn.addEventListener('mousemove',e=>{
      const r=btn.getBoundingClientRect();
      btn.style.transform=`translate(${(e.clientX-(r.left+r.width/2))*.22}px,${(e.clientY-(r.top+r.height/2))*.22}px) scale(1.03)`;
    });
    btn.addEventListener('mouseleave',()=>btn.style.transform='');
  });

})();
